import * as Yup from "yup";

const passwordLengthRegex = /^.{8,50}$/;

export const validationSchema = [
  {
    name: "fullName",
    placeholder: "Họ và tên",
    validate: Yup.string()
      .required("Hãy nhập họ tên")
      .matches(
        /^.{8,100}$/,
        "Họ tên phải ít nhất 8 ký tự, không vượt quá 100 ký tự"
      ),
  },
  {
    name: "username",
    placeholder: "Tên đăng nhập",
    validate: Yup.string()
      .required("Vui lòng nhập tên đăng nhập")
      .matches(/^\S*$/, "Tên đăng nhập không được chứa khoảng cách")
      .matches(/^.{6,50}$/, "Tên đăng nhập phải từ 6 đến 50 ký tự"),
  },
  {
    name: "email",
    validate: Yup.string()
      .required("Vui lòng nhập email")
      .matches(
        /^(?![.@])[^\s@]*@[^\s@]*\.[^\s@.]+(?<![.@])$/,
        "Email phải có ký tự '@' và ít nhất một ký tự '.' sau '@', không được chứa khoảng trắng, không được bắt đầu hoặc kết thúc bằng dấu '.' hoặc '@'."
      )
      .matches(
        /^.{10,100}$/,
        "Email phải ít nhất 10 ký tự, không vượt quá 100 ký tự"
      ),
  },
  {
    name: "phoneNumber",
    placeholder: "Số điện thoại",
    validate: Yup.string()
      .required("vui lòng nhập số điện thoại")
      .matches(
        /^0\d{9}$/,
        "Số điện thoại phải bắt đầu từ chữ số 0 và gồm 10 chữ số"
      ),
  },
  {
    name: "currentPassword",
    placeholder: "Mật khẩu hiện tại",
    validate: Yup.string().test("password-validation", "", function (value) {
      const { password, currentPassword, confirmPassword } = this.parent;
      if (
        password?.length > 0 ||
        currentPassword?.length > 0 ||
        value ||
        confirmPassword?.length > 0
      ) {
        if (!value) {
          return this.createError({
            message: "Vui lòng nhập mật khẩu hiện tại",
          });
        }
        if (!passwordLengthRegex.test(value)) {
          return this.createError({
            message: "Mật khẩu phải từ 8 đến 50 ký tự",
          });
        }
      }
      return true;
    }),
  },
  {
    name: "password",
    placeholder: "Mật khẩu",
    validate: Yup.string().test(
      "password-validation",
      "",
      function (value, context) {
        const { currentPassword, confirmPassword } = this.parent;

        if (
          currentPassword?.length > 0 ||
          value ||
          confirmPassword?.length > 0
        ) {
          if (!value) {
            return this.createError({ message: "Vui lòng nhập mật khẩu" });
          }
          if (!passwordLengthRegex.test(value)) {
            return this.createError({
              message: "Mật khẩu phải từ 8 đến 50 ký tự",
            });
          }
        }
        return true;
      }
    ),
  },
  {
    name: "confirmPassword",
    placeholder: "Xác nhận mật khẩu",
    validate: Yup.string().test("password-validation", "", function (value) {
      const { password } = this.parent;
      if (password?.length > 0) {
        if (!value) {
          return this.createError({
            message: "Vui lòng nhập Xác nhận mật khẩu",
          });
        }
        if (value !== password) {
          return this.createError({
            message: "Xác nhận mật khẩu không khớp với Mật khẩu",
          });
        }
        if (!passwordLengthRegex.test(value)) {
          return this.createError({
            message: "Xác nhận mật khẩu phải từ 8 đến 50 ký tự",
          });
        }
      }
      return true;
    }),
  },
];
